export const TABLE_FILTERS = {
  GetRelativeDataRange: ({ beforeMonths, afterMonths }: { beforeMonths?: number; afterMonths?: number }) => {
    const now = new Date();
    return {
      before: beforeMonths ? new Date(now.getFullYear(), now.getMonth() - beforeMonths) : undefined,
      after: afterMonths ? new Date(now.getFullYear(), now.getMonth() - afterMonths) : undefined,
    };
  },
};
